// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Models
import { AppCleanup } from '../models';

// Environment
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class LoggingService extends AppCleanup implements OnInit, OnDestroy {
	public appInsights: ApplicationInsights;

	constructor() {
		super();
		if (environment.appInsights.instrumentationKey) {
			// Checking if key exists
			this.loadAppInsights();
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	loadAppInsights() {
		this.appInsights = new ApplicationInsights({
			config: {
				instrumentationKey: environment.appInsights.instrumentationKey,
				enableAutoRouteTracking: true, // option to log all route changes
			},
		});

		this.appInsights?.loadAppInsights();
	}

	logPageView(name?: string, url?: string) {
		// option to call manually
		this.appInsights?.trackPageView({
			name: name,
			uri: url,
		});
	}

	logEvent(name: string, properties?: { [key: string]: any }) {
		this.appInsights?.trackEvent({ name: name }, properties);
	}

	logMetric(name: string, average: number, properties?: { [key: string]: any }) {
		this.appInsights?.trackMetric({ name: name, average: average }, properties);
	}

	logException(exception: Error, severityLevel?: number) {
		this.appInsights?.trackException({ exception: exception, severityLevel: severityLevel });
	}

	logTrace(message: string, properties?: { [key: string]: any }) {
		this.appInsights?.trackTrace({ message: message }, properties);
	}
}
